import React from "react";
import {NumericFormat, NumericFormatProps, NumberFormatValues} from 'react-number-format';
import ObjectUtil from "utils/ObjectUtil";
import {ValidationRuleNames} from "../../../common/validation/rules/ValidationRule";
import {ValidationRuleBytesProps} from "../../../common/validation/rules/ValidationRuleBytes";
import useUIValidator from "common/validation/component/UseUIValidator";
import classNames from "classnames";

export interface UIInputNumberProps {
    value?: number;
    valueChanged?: (value: number) => void;
    min?: number;
    max?: number;
    displayOnly?: boolean;
    style?: React.CSSProperties;
    attrs?: NumericFormatProps;
    className?: string;
    rules?: Array<ValidationRuleNames | ((value: any) => string | undefined)>;
    bytes?: ValidationRuleBytesProps;
}

export default UIInputNumber;

function UIInputNumber({
                           value,
                           valueChanged,
                           min,
                           max,
                           displayOnly,
                           style = {},
                           attrs = {},
                           className = 'tf tf-md w100p',
                           rules = [],
                           bytes = {}
                       }: UIInputNumberProps) {
    const ref = React.useRef(null);

    if (rules.indexOf("number") < 0) {
        rules.push("number");
    }

    if (typeof min == "number") {
        rules.push((value: any) => {
            const sqlInjectionRegex = /(\b(insert|delete|update|select|drop|create|rename|truncate|alter|commit|rollback|grant|revoke|savepoint|lock|unlock|set)\b|\'\s?or\s?\'|\"or\")(?!.*['"<>])/ig;
            sqlInjectionRegex.test(value)
            if (typeof value === "number" && value < min) {
                return `입력값이 최소입력갑(${min})보다 작습니다.`;
            }
            return undefined;
        });
    }

    if (typeof max == "number") {
        rules.push((value: any) => {
            if (typeof value === "number" && value > max) {
                return `입력값이 최대입력갑(${min})보다 큽니다.`;
            }
            return undefined;
        })
    }

    const {required, valueChecker, errorClassName} = useUIValidator({rules: rules, bytes: bytes})

    style.textAlign = ObjectUtil.defaultIfNull(style.textAlign, "right");

    attrs.thousandSeparator = ObjectUtil.defaultIfNull(attrs.thousandSeparator, true);

    if (displayOnly === true) {
        attrs.displayType = "text";
    }

    React.useEffect(() => {
        valueChecker.setValue(value);
    }, [value]);

    return (
        <NumericFormat
            className={classNames(className, errorClassName)}
            value={value}
            style={{...style}}
            {...attrs}
            onValueChange={(values: NumberFormatValues): void => {
                if (valueChanged != null) {
                    valueChanged(values.floatValue == null ? ObjectUtil.undefined : values.floatValue);
                }
            }}
            isAllowed={(values: NumberFormatValues): boolean => {
                if (values.floatValue != null) {
                    if (min != null && values.floatValue < min) {
                        return false;
                    }

                    if (max != null && values.floatValue > max) {
                        return false;
                    }
                }

                if (attrs?.isAllowed) {
                    return attrs.isAllowed(values);
                }

                return true;
            }}
            required={required}
            data-security={"off"}
            data-value-rule={rules}
            data-value-bytes={bytes}
            data-validation-message={valueChecker.message}
        />
    );
}
